export default __webpack_public_path__ + "static/media/jum2.324944a1.jpg";